export function videoLazy() {
    const lazyVideos = document.querySelectorAll('video');

    if ("IntersectionObserver" in window) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    const source = video.querySelector('source[data-src]');
                    if (source && !source.src) {
                        source.src = source.dataset.src;
                        video.load();
                        const playPromise = video.play();
                        if (playPromise !== undefined) {
                            playPromise.catch(function() {});
                        }
                    }
                    observer.unobserve(video);
                }
            });
        });

        lazyVideos.forEach(video => videoObserver.observe(video));
    }
}